// Le punte di freccia delle connessioni, definite una volta sola per tutto il canvas.
//
// Prima ogni connessione si portava dietro il proprio <defs><marker><polygon>: sulla formula del
// torneo 98 erano 257 defs, 257 marker e 257 polygon, cioe' 771 elementi SVG per disegnare una
// manciata di triangoli tutti uguali fra loro a parte il colore. I marker in Chrome non si
// accorpano e obbligano a lavoro di disegno per ogni path che li riferisce: duplicarli e' il modo
// piu' caro di ottenere lo stesso risultato.
//
// I colori sono un insieme finito e noto, quindi si emette un marker per colore e le connessioni
// lo riferiscono per id.

const NORMALI = {
  SquadraToGirone: '#66BB6A',
  SquadraToDiretta: '#FF7043',
  SquadraToClassifica: '#BA68C8',
  GironeToDiretta: '#FFB74D',
  GironeToGirone: '#BA68C8',
  GironeToClassifica: '#CE93D8',
  DiretteToClassifica: '#E1BEE7',
  ClassificaToGirone: '#BA68C8',
  ClassificaToDiretta: '#CE93D8',
  ClassificaToClassifica: '#E1BEE7',
  default: '#666',
};

const SOTTO_IL_PUNTATORE = {
  SquadraToGirone: '#4CAF50',
  SquadraToDiretta: '#FF5722',
  SquadraToClassifica: '#9C27B0',
  GironeToDiretta: '#FF9800',
  GironeToGirone: '#9C27B0',
  GironeToClassifica: '#AB47BC',
  DiretteToClassifica: '#BA68C8',
  ClassificaToGirone: '#9C27B0',
  ClassificaToDiretta: '#AB47BC',
  ClassificaToClassifica: '#BA68C8',
  default: '#2196F3',
};

// Quando il nodo a cui la connessione e' attaccata e' sotto il puntatore: tinte piu' cariche.
const NODO_EVIDENZIATO = {
  SquadraToGirone: '#2E7D32',
  SquadraToDiretta: '#D84315',
  SquadraToClassifica: '#4A148C',
  GironeToDiretta: '#EF6C00',
  GironeToGirone: '#6A1B9A',
  GironeToClassifica: '#7B1FA2',
  DiretteToClassifica: '#8E24AA',
  ClassificaToGirone: '#6A1B9A',
  ClassificaToDiretta: '#8E24AA',
  ClassificaToClassifica: '#9C27B0',
  default: '#1565C0',
};

export const COLORE_SELEZIONATA = '#1976D2';

/**
 * Il colore di una connessione.
 * @param {string} tipo tipo del link (SquadraToGirone, GironeToDiretta, ...)
 * @param {{selezionata?: boolean, nodoEvidenziato?: boolean, sottoIlPuntatore?: boolean}} stato
 */
export const coloreConnessione = (tipo, stato = {}) => {
  if (stato.selezionata) return COLORE_SELEZIONATA;
  const tavolozza = stato.nodoEvidenziato ? NODO_EVIDENZIATO
    : stato.sottoIlPuntatore ? SOTTO_IL_PUNTATORE
      : NORMALI;
  return tavolozza[tipo] || tavolozza.default;
};

/** Tutti i colori che una freccia puo' assumere, senza ripetizioni. */
export const COLORI_FRECCIA = [...new Set([
  COLORE_SELEZIONATA,
  ...Object.values(NORMALI),
  ...Object.values(SOTTO_IL_PUNTATORE),
  ...Object.values(NODO_EVIDENZIATO),
])];

/** L'id del marker per un colore. Niente '#': non e' valido dentro un id. */
export const idFreccia = (colore) => `freccia-${colore.replace('#', '')}`;

/** Il riferimento da mettere in markerEnd. */
export const riferimentoFreccia = (colore) => `url(#${idFreccia(colore)})`;
